/**
 * DraftIndicator Component
 * 
 * Shows the number of unpublished draft changes
 * Displays in the header/nav bar
 * Clicking opens modal to view and manage drafts
 */

import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Button } from './ui'
import { useAuthStore } from '../stores/authStore'
import useDraftStore from '../stores/draftStore'
import DraftChangesModal from './DraftChangesModal'

export default function DraftIndicator() {
  const [searchParams] = useSearchParams()
  const { user } = useAuthStore()
  const { getCount, initialize, isInitialized } = useDraftStore()
  const [isModalOpen, setIsModalOpen] = useState(false)
  
  const { currentClinicId } = useAuthStore()
  const clinicId = currentClinicId || searchParams.get('clinic') || 'tmates'
  const count = getCount()
  
  // Initialize draft store when clinic or user changes
  useEffect(() => {
    if (user && clinicId) {
      const userId = user.id // Backend uses 'id', not '_id'
      const { userId: storeUserId, clinicId: storeClinicId } = useDraftStore.getState()
      
      // Re-initialize if not initialized OR if clinic/user changed
      if (!isInitialized || storeUserId !== userId || storeClinicId !== clinicId) {
        console.log('[DRAFT INDICATOR] Re-initializing draft store due to clinic/user change:', { clinicId, userId, oldClinicId: storeClinicId, oldUserId: storeUserId })
        initialize(clinicId, userId)
      }
    }
  }, [user, clinicId, initialize, isInitialized])
  
  if (count === 0) {
    return null
  }
  
  return (
    <>
      <Button
        variant="outline"
        size="sm"
        onClick={() => setIsModalOpen(true)}
        className="flex items-center gap-2 bg-amber-50 dark:bg-amber-950 border-amber-300 dark:border-amber-800 text-amber-900 dark:text-amber-100 hover:bg-amber-100 dark:hover:bg-amber-900"
        title="Click to view and manage unpublished changes"
      >
        <span className="w-2 h-2 rounded-full bg-amber-500 animate-pulse"></span>
        <span className="font-medium">{count} unpublished change{count !== 1 ? 's' : ''}</span>
      </Button>
      
      <DraftChangesModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  )
}

